import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { ModalController, NavParams, Events } from 'ionic-angular';
import { WidgetsProvider } from '../../providers/widgets/widgets';
import { Subject } from 'rxjs/Subject';
import { CoBibItemPage } from '../../pages/co-bib-item/co-bib-item';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { CoBibItemProvider } from '../../providers/co-bib-item/co-bib-item';
import { AnalyticsProvider } from '../../providers/analytics/analytics';

/**
 * Generated class for the CoRecommendedReadsWidgetComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-recommended-reads-widget',
  templateUrl: 'co-recommended-reads-widget.html'
})
export class CoRecommendedReadsWidgetComponent {
  public updateObserver: Subject<Array<number>>;
  @Input() clientKeyword;
  @Input() widgetId;
  @Input() moreLinkText;
  @Input() moreText;
  data: any;
  allLanes: boolean = false;
  sections: any;
  intro: string;
  recTitle: string;
  loadPage: boolean = false;
  @ViewChild('scrollC') scrollC: any;
  constructor(private modalCtrl: ModalController, private navParams: NavParams, private widgetProvider: WidgetsProvider, private events: Events, private timeout: TimeoutFunctionsProvider, private bibProvider: CoBibItemProvider, private analytics: AnalyticsProvider) {
    this.events.subscribe('timeoutCalled', () => this.timeout.doLogoutFunctions(this));
    if (this.navParams.data.allLanes) {
      this.allLanes = this.navParams.data.allLanes;
    }
    setInterval(() => this.update(), 500);//#TODO: fix this silly hack
  }

  public update() {
    this.updateObserver.next();
  }

  ionViewDidLoad() {
    if (this.allLanes && this.scrollC) {
      let mod = document.getElementsByClassName('rec-reads-modal').item(0).getElementsByClassName('modal-wrapper').item(0);
      // console.log(this.scrollC._scrollContent);
      this.scrollC._scrollContent.nativeElement.style.height = `${mod.getBoundingClientRect().height - 100}px`;
    }
  }

  ngOnInit() {
    this.updateObserver = new Subject();
    if (this.widgetId) {
      this.widgetProvider.getWidgetData(this.widgetId).then((res) => {
        console.log(res);
        if (res.data) {
          console.log(res);
          this.data = res.data;
          this.sections = this.data.sections;
          this.sections.forEach(section => {
            section.items.forEach(item => {
              item.cover = `http://covers0.communico.co/isbn/o/${item.isbn}.jpg`;
              item.error = "http://covers0.communico.co/gen/cover?title=" + encodeURIComponent(item.title);
              return item;
            });
            return section;
          });
          this.intro = this.data.intro;
          this.recTitle = res.name || this.data.title;
          this.loadPage = true;
        }
      })
    } else if (this.navParams.data.sections) {
      this.sections = this.navParams.data.sections;
      this.intro = this.navParams.data.data.intro;
      this.recTitle = this.navParams.data.data.title;
      this.data = this.navParams.data.data;
      this.loadPage = true;
    }
  }

  openRecReads() {
    let modal = this.modalCtrl.create(CoRecommendedReadsWidgetComponent, { allLanes: true, sections: this.sections, data: this.data }, { cssClass: "rec-reads-modal" });

    modal.present();
  }

  showItem(item) {
    // let modal = this.modalCtrl.create(CoBibItemPage, {isbn: isbn});
    // modal.present();
    if (item.bibId) {
      this.bibProvider.showItemFromBibId(item.bibId);
    } else if (item.upc) {
      this.bibProvider.showItemFromUPC(item.upc);
    } else if (item.isbn) {
      this.bibProvider.showItemFromISBN(item.ibsn);
    }
    this.analytics.trackEvent('Recommended Reads', 'View Item', item.bibId || item.upc || item.isbn);
  }

}



// WEBPACK FOOTER //
// ./src/components/co-recommended-reads-widget/co-recommended-reads-widget.ts